




















import Vue, { PropType } from 'vue';
import { DatePicker } from 'v-calendar';
import { mapGetters } from 'vuex';
import { AppointmentType, AvailableTimeSlot, CalendarConfig, Member, ScheduleApptDetails, Slot } from '@/types';
import { NoApptDatesAvailable, EventType } from '@/constants';
import InfoIcon from '@/assets/icons/InfoIcon.vue';
import { getAvailableTimeSlots } from '@/api';
import { formatDateFormat, getUtcDate, hideLoader, showLoader } from '@/util';
import { hideCalendarPreviousMonth } from '../services/service';

export default Vue.extend({
  components: {
    DatePicker,
    InfoIcon
  },
  data () {
    return {
      date: '',
      availableSlots: [] as AvailableTimeSlot[],
      availableDates: [] as string[],
      NoApptDatesAvailable,
      startDate: '',
      endDate: '',
      EventType,
      disableAllDates: {
        repeat: {
          weekdays: [1, 2, 3, 4, 5, 6, 7]
        }
      }
    }
  },
  props: {
    appointmentType: {
      type: Object as PropType<AppointmentType>,
      required: true
    },
    appointmentDetails: {
      type: Object as PropType<ScheduleApptDetails>,
      required: true
    }
  },
  computed: {
    ...mapGetters(['selectedJobDetails']),
    modelConfig (): CalendarConfig {
      return {
        inline: true,
        type: 'string',
        mask: 'YYYY-MM-DD'
      };
    },
    isSelectedDate (): boolean {
      return !!this.date;
    }
  },
  mounted () {
    document.querySelectorAll('span.flatpickr-weekday').forEach((day) => {
      (day as HTMLElement).innerText = (day as HTMLElement).innerText.slice(0, 1);
    });
    if (this.appointmentDetails.date) {
      this.date = this.appointmentDetails.date;
    }
  },
  methods: {
    setDate () {
      if (this.date) {
        this.$emit(EventType.SET_APPOINTMENT_DATE, this.date);
      }
    },
    async fetchAvailableDates () {
      showLoader();
      const availableDatesSet = [] as string[];
      await Promise.all(
        this.appointmentDetails.teamMember.map(async (member: Member) => {
          const params = {
            buffer: this.appointmentType.buffer,
            type: this.appointmentType.stage.toLowerCase(),
            areaId: this.selectedJobDetails.areaId
          };
          const response = await getAvailableTimeSlots(member.userId, this.appointmentType.duration, this.startDate, this.endDate, '1', params);
          const slots = (response?.availability?.availableSlots || []) as Slot[];
          this.availableSlots.push({
            userId: member.userId,
            slots: slots
          });
          const individualDates = Array.from(new Set(slots.map((slot) => formatDateFormat(slot.start, 'YYYY-MM-DD'))));
          individualDates.forEach(date => {
            if (new Date(date).getDay() !== 0 && new Date(date).getDay() !== 6) {
              availableDatesSet.push(date);
            }
          });
        })
      );
      this.availableDates = Array.from(new Set(availableDatesSet));
      if (!this.availableDates.includes(this.date)) {
        this.date = '';
      }
      hideLoader();
    },
    calculateEndDate (refDate: Date | string) {
      const start = new Date(refDate);
      start.setMonth(start.getMonth() + 1); // set month as next month
      start.setDate(1); // get the last day of previous month
      this.endDate = getUtcDate(new Date(start), 'YYYY-MM-DD');
      this.endDate = `${this.endDate}T00:00:00Z`;
    },
    async onMonthChange (data: any) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const startDate = formatDateFormat(`01 ${months[data.month - 1]} ${data.year}`, 'YYYY-MM-DD');
      this.startDate = startDate > formatDateFormat(new Date(), 'YYYY-MM-DD') ? getUtcDate(new Date(startDate)) : getUtcDate(new Date());
      this.calculateEndDate(this.startDate);
      await this.fetchAvailableDates();
      hideCalendarPreviousMonth(data.month - 1);
    }
  }
});

